import React from "react";
import { useField, useFormikContext } from "formik";

export const Textarea = ({ name, autoSubmit = false, ...props }) => {
  const [field, meta] = useField(name);
  const { submitForm } = useFormikContext();

  return (
    <div>
      <textarea
        value={field.value}
        name={field.name}
        onChange={(option) => {
          field.onChange({ target: { name: field.name, value: option } });
          autoSubmit && submitForm();
        }}
        onBlur={() => {
          field.onBlur({ target: { name: field.name } });
          autoSubmit && submitForm();
        }}
        style={{
          border: `1px solid ${meta.touched && meta.error ? "red" : "#e4e6ef"}`,
          width: "99%",
          height: "100px",
        }}
        {...field}
        {...props}
      />
      {meta.touched && meta.error ? (
        <div className="error" style={{ color: "red" }}>
          {meta.error}
        </div>
      ) : null}
    </div>
  );
};
